// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ConfigService } from '@med/app/core/config/config.service';

declare let ga: any;

@Injectable()
export class GoogleAnalyticsService {

  constructor(
    private router: Router,
    private configService: ConfigService,
  ) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        ga('create', this.configService.getConfig().googleAnalytics, 'auto');
        ga('set', 'page', event.url);
        ga('send', 'pageview');
      }
    });
  }

}
